(() => {
  const configNode = document.getElementById('mwk-assistant-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.strings;
  const state = { open: false, step: 0, busy: false, map: null, sea: false, color: '#ffffff', titleId: null, titleName: null, textNumber: 0, heading: '', font: '', instance: null };
  const entryParams = new URLSearchParams(location.search);
  const directEntry = location.pathname === config.productUrl && !entryParams.has('mwk-cart-editor') && !entryParams.has('mwk-edit-options');
  let panel, gallery, observer, scheduled = false, autoStarted = false, clipartKey = '', draftRestored = false, saveDialog;
  const draftKey = 'mwk-design-assistant-v20-draft';
  const pendingDraftKey = 'mwk-design-assistant-v20-pending-save-';
  const fpd = () => window.FPD?.instance;
  const root = () => document.getElementById('fpd');
  const esc = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const elements = () => fpd()?.getElements(-1, 'all', false) || [];
  const mapLayers = config.mapLayers || [];
  const selectedMapLayers = () => Object.fromEntries(mapLayers.map(layer => [layer.key, elements().some(element => element.title === layer.title)]));
  function currentMapFamily() {
    const title = fpd()?.productViews?.[0]?.productTitle;
    return title ? mapFamily(title) : state.map?.family || 'states';
  }
  function currentMapSea() {
    const title = fpd()?.productViews?.[0]?.productTitle;
    return title ? /meer/i.test(title) : state.sea;
  }
  function mapLayerAppearance(layer, family, sea = false) {
    const names = layer.key === 'antarctica' && family.startsWith('names_') && layer.namesSource;
    return { source: names ? layer.namesSource : layer.source, fill: names ? (sea ? layer.namesSeaFill : layer.namesFill) : false, colorMode: 'tint' };
  }
  function withMapLayers(product, selected, map) {
    const copy = JSON.parse(JSON.stringify(product));
    for (const view of copy) view.elements = (view.elements || []).filter(element => !mapLayers.some(layer => layer.title === element.title));
    const view = copy[0];
    if (!view) throw new Error(t.not_ready);
    const bg = view.elements.find(element => /hintergrundfarbe ändern/i.test(element.title || ''))?.parameters;
    const customIndex = view.elements.findIndex(element => element.parameters?.isCustom);
    const overlays = mapLayers.filter(layer => selected[layer.key]).map(layer => ({
      title: layer.title, source: mapLayerAppearance(layer, map.family, map.sea).source, type: 'image', parameters: {
        left: bg?.left ?? 500, top: (bg?.top ?? 325) + (layer.key === 'oceans' ? 35 : 0), originX: 'center', originY: 'center',
        scaleX: bg ? bg.scaleX / 5 : 929.5 / 3250, scaleY: bg ? bg.scaleY / 5 : 621 / 2250,
        autoCenter: false, autoSelect: false, draggable: false, rotatable: false, resizable: false,
        removable: false, zChangeable: false, colors: false, fill: mapLayerAppearance(layer, map.family, map.sea).fill, colorMode: 'tint', opacity: 1,
        excludeFromExport: false, adminLocked: true, isCustom: false, price: 0, boundingBoxMode: 'none'
      }
    }));
    view.elements.splice(customIndex < 0 ? view.elements.length : customIndex, 0, ...overlays);
    return copy;
  }
  function syncMapProperties() {
    if (!fpd()?.productCreated) return;
    const selected = selectedMapLayers();
    document.querySelectorAll('#MainContent product-form form.form').forEach(form => {
      mapLayers.forEach(layer => {
        let input = form.querySelector(`[data-mwk-map-property="${layer.key}"]`);
        if (!input) {
          input = document.createElement('input'); input.type = 'hidden';
          input.name = `properties[${layer.property}]`; input.dataset.mwkMapProperty = layer.key;
          form.append(input);
        }
        const value = selected[layer.key] ? t.option_yes : t.option_no;
        if (input.value !== value) input.value = value;
      });
    });
  }
  async function chooseMapLayer(key, enabled) {
    const instance = fpd(), c = canvas(), layer = mapLayers.find(item => item.key === key);
    if (!layer || !c) throw new Error(t.not_ready);
    let existing = elements().find(element => element.title === layer.title);
    const appearance = mapLayerAppearance(layer, currentMapFamily(), currentMapSea());
    if (enabled && existing && existing.source !== appearance.source) {
      c.removeElement(existing); existing = null;
    }
    if (!enabled && existing) c.removeElement(existing);
    else if (enabled && !existing) {
      const bg = background();
      const options = {
        left: bg?.left ?? 500, top: (bg?.top ?? 325) + (key === 'oceans' ? 35 : 0),
        originX: 'center', originY: 'center',
        scaleX: bg ? bg.width * bg.scaleX / 3250 : 929.5 / 3250,
        scaleY: bg ? bg.height * bg.scaleY / 2250 : 621 / 2250,
        autoCenter: false, autoSelect: false, draggable: false, rotatable: false, resizable: false,
        removable: false, zChangeable: false, colors: false, fill: appearance.fill, colorMode: appearance.colorMode, opacity: 1,
        excludeFromExport: false, adminLocked: true, isCustom: false, price: 0, boundingBoxMode: 'none'
      };
      await waitFor(instance, 'elementAdd', () => c.addElement('image', appearance.source, layer.title, options),
        event => event.detail?.element?.title === layer.title);
    }
    else if (enabled && existing && appearance.fill && existing.fill !== appearance.fill) setOptions(existing, { fill: appearance.fill });
    instance.deselectElement(); syncMapProperties(); resize();
  }
  function ownedTitle() {
    if (state.titleId == null) return;
    const all = elements();
    let element = all.find(item => String(item.id) === String(state.titleId));
    if (!element) {
      const candidates = all.filter(item => item.getType?.() === 'text' && item.title === (state.titleName || t.heading_element));
      element = candidates.find(item => item.text === state.heading) || (candidates.length === 1 ? candidates[0] : undefined);
      if (element) state.titleId = element.id;
    }
    return element;
  }
  const canvas = () => fpd()?.currentViewInstance?.fabricCanvas;
  const setOptions = (element, options) => {
    const c = element?.canvas;
    if (!c?.setElementOptions) throw new Error(t.unsupported);
    c.setElementOptions(options, element);
    c.requestRenderAll();
  };
  function mapFamily(name) {
    if (/flaggen.*bunt/i.test(name)) return 'flags_color';
    if (/flaggen/i.test(name)) return 'flags_gray';
    if (/namen.*schwarz/i.test(name)) return 'names_black';
    if (/namen/i.test(name)) return 'names_gray';
    return /bundesstaat/i.test(name) ? 'states' : 'borders';
  }
  function maps() {
    const native = [...(root()?.querySelectorAll('fpd-module-products .fpd-grid .fpd-item[data-index]') || [])].map(item => ({
      index: Number(item.dataset.index), nativeIndex: Number(item.dataset.index), name: item.dataset.title.trim(), image: item.dataset.source,
      sea: /meer/i.test(item.dataset.title), states: /bundesstaat/i.test(item.dataset.title), family: mapFamily(item.dataset.title)
    }));
    const added = (window.MWKDesignTemplates || []).filter(product => Array.isArray(product) && product[0]?.product_id).map(product => {
      const view = product[0], name = view.productTitle.trim();
      return { index: 10000 + view.product_id, name, image: view.productThumbnail || view.thumbnail, sea: /meer/i.test(name), family: mapFamily(name), product };
    });
    return [...native, ...added.filter(map => !native.some(item => item.name === map.name))];
  }
  function fonts() {
    const available = (fpd()?.mainOptions?.fonts || []).map(font => typeof font === 'string' ? font : font.name).filter(Boolean);
    const current = ownedTitle()?.fontFamily;
    return [...new Set([...(available.length ? available : ['Arial']), ...(current ? [current] : [])])];
  }
  function cliparts() {
    const choices = new Map();
    [...(root()?.querySelectorAll('fpd-module-designs .fpd-item[data-source]') || [])].forEach(item => {
      if (!choices.has(item.dataset.source)) choices.set(item.dataset.source, {
        source: item.dataset.source, title: item.dataset.title || '', item
      });
    });
    return [...choices.values()];
  }
  function smallClipart(element) {
    if (!element?.canvas || element.getType?.() !== 'image' || !element.isCustom) return;
    const box = background(), c = element.canvas;
    const width = box?.width || c.getWidth(), height = box?.height || c.getHeight();
    const factor = Math.min(1, width * .1 / element.getScaledWidth(), height * .12 / element.getScaledHeight());
    if (!Number.isFinite(factor) || factor <= 0) return;
    setOptions(element, { autoCenter: false, scaleX: element.scaleX * factor, scaleY: element.scaleY * factor, left: width * .78, top: height * .78, originX: 'center', originY: 'center' });
  }
  function savedDraft(key = draftKey) {
    try {
      const draft = JSON.parse(localStorage.getItem(key));
      return draft?.version === 1 && draft.productUrl === config.productUrl && Array.isArray(draft.product) && draft.product.length ? draft : null;
    } catch (_) { return null; }
  }
  function draftUrl(draft) {
    const url = new URL(config.productUrl, location.origin);
    url.searchParams.set('preview_theme_id', config.themeId);
    url.searchParams.set('mwk-assistant', '1');
    url.searchParams.set('mwk-draft', '1');
    url.searchParams.set('pb', '0');
    if (draft.variantId) url.searchParams.set('variant', draft.variantId);
    return url.href;
  }
  async function captureDraft() {
    if (!fpd()?.productCreated) throw new Error(t.not_ready);
    if (state.step === 2 && state.heading.trim()) await saveHeading();
    fpd().deselectElement();
    const draft = { version: 1, productUrl: config.productUrl, variantId: currentVariant()?.id, product: fpd().getProduct(), time: Date.now(), state: { mapIndex: state.map?.index, mapName: state.map?.name, color: state.color, sea: state.sea, heading: state.heading, font: state.font, titleName: state.titleName, titleId: state.titleId, textNumber: state.textNumber, step: state.step } };
    if (!draft.product?.length) throw new Error(t.not_ready);
    return draft;
  }
  const account = () => window.MWKDesignAccount;
  let restoredAccountName = '', restoreStarted = false;
  function saveDialogShell(title, body) {
    saveDialog?.close();
    const dialog = document.createElement('dialog'); saveDialog = dialog;
    dialog.id = 'mwk-assistant-save-dialog';
    dialog.setAttribute('aria-labelledby','mwk-assistant-save-title');
    dialog.innerHTML = `<header><h2 id="mwk-assistant-save-title">${esc(title)}</h2>${button('×',`data-save-close aria-label="${esc(t.save_close)}" autofocus`)}</header><div class="mwk-assistant-save-body">${body}<p data-save-error role="alert"></p></div>`;
    dialog.querySelector('[data-save-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('keydown',event=>event.stopPropagation());
    dialog.addEventListener('close',()=>{dialog.remove();if(saveDialog===dialog)saveDialog=null;document.getElementById('mwk-assistant-save')?.focus();});
    document.body.append(dialog);dialog.showModal();return dialog;
  }
  function accountSaveDialog(autoSave = false) {
    const connected = account()?.connected();
    const dialog = saveDialogShell(t.save_design,`<p class="mwk-assistant-save-intro">${esc(connected ? t.save_logged_in : t.account_save_intro)}</p><label for="mwk-design-name">${esc(t.design_name)}</label><input id="mwk-design-name" type="text" maxlength="80" value="${esc(restoredAccountName)}" placeholder="${esc(t.design_name_placeholder)}"><button type="button" data-save-account class="mwk-assistant-save-primary">${esc(connected ? t.save_to_account : t.account_login_save)}</button><p data-save-status role="status" aria-live="polite">${esc(t.account_storage_hint)}</p><p class="mwk-assistant-save-hint">${esc(t.save_purchase_hint)}</p>`);
    const name = dialog.querySelector('#mwk-design-name'), save = dialog.querySelector('[data-save-account]');
    const update = () => { save.disabled = !account() || !name.value.trim() || name.disabled || state.busy; };
    name.addEventListener('input',update);update();
    const authenticate = async () => {
      const draft = await captureDraft();
      await account().authenticate(draft,name.value.trim(),'save-confirmed');
    };
    save.addEventListener('click',async()=>{
      if (state.busy) return;
      state.busy = true;save.disabled=true;name.disabled=true;
      dialog.querySelector('[data-save-error]').textContent='';
      try {
        name.disabled=false;
        if (!account().connected()) {await authenticate();return;}
        name.disabled=true;
        dialog.querySelector('[data-save-status]').textContent=t.account_saving;
        const saved = await account().save(await captureDraft(),name.value.trim());
        restoredAccountName = saved.name;
        dialog.querySelector('.mwk-assistant-save-body').innerHTML=`<p role="status">${esc(t.account_saved)}</p><strong class="mwk-assistant-saved-name">${esc(saved.name)}</strong>${button(t.account_saved_designs,'data-account-designs','mwk-assistant-save-primary')}<p class="mwk-assistant-save-hint">${esc(t.account_storage_hint)}</p>`;
        dialog.querySelector('[data-account-designs]').addEventListener('click',accountDesignsDialog);
      } catch(cause) {
        dialog.querySelector('[data-save-status]').textContent=t.account_storage_hint;
        dialog.querySelector('[data-save-error]').textContent=cause.message||t.save_failed;
      } finally {state.busy=false;name.disabled=false;update();}
    });
    if (account()?.error()) dialog.querySelector('[data-save-error]').textContent=account().error().message;
    if (autoSave && connected && name.value.trim()) save.click();
  }
  async function accountDesignsDialog() {
    const dialog = saveDialogShell(t.account_saved_designs,`<p data-save-status role="status">${esc(t.account_loading)}</p><div data-account-list></div>`);
    const list = dialog.querySelector('[data-account-list]');
    try {
      if (!account()?.connected()) {
        dialog.querySelector('[data-save-status]').textContent=t.save_login_hint;
        list.innerHTML=button(t.save_login,'data-account-connect','mwk-assistant-save-primary');
        list.querySelector('button').addEventListener('click',async event=>{
          event.currentTarget.disabled=true;
          try {await account().authenticate(await captureDraft(),'','list');}
          catch(cause) {dialog.querySelector('[data-save-error]').textContent=cause.message||t.save_failed;event.currentTarget.disabled=false;}
        });return;
      }
      const designs = await account().list();
      if (!dialog.open) return;
      dialog.querySelector('[data-save-status]').textContent=designs.length ? '' : t.account_empty;
      list.className='mwk-assistant-saved-list';
      list.innerHTML=designs.map(design=>`<div><strong>${esc(design.name)}</strong>${button(t.account_open,`data-account-open="${esc(design.id)}"`,'mwk-assistant-save-primary')}</div>`).join('');
      list.querySelectorAll('[data-account-open]').forEach(control=>control.addEventListener('click',async()=>{
        list.querySelectorAll('button').forEach(button=>button.disabled=true);
        try {
          const saved = await account().load(control.dataset.accountOpen);
          await applySavedDraft(saved.draft,t.restored_notice);
          restoredAccountName=saved.name;dialog.close();
        } catch(cause) {dialog.querySelector('[data-save-error]').textContent=cause.message||t.save_failed;}
        finally {list.querySelectorAll('button').forEach(button=>button.disabled=false);}
      }));
    } catch(cause) {dialog.querySelector('[data-save-error]').textContent=cause.message||t.save_failed;}
  }
  function saveDraft() {
    if (state.busy || !fpd()?.productCreated) return;
    accountSaveDialog();
  }
  async function applySavedDraft(draft, notice) {
    await run(async()=>{
      if (draft.variantId && currentVariant()?.id !== Number(draft.variantId)) {
        const catalog = JSON.parse(document.getElementById('mwk-accessory-catalog').textContent);
        const variant = catalog.mapVariants.find(item=>item.id===Number(draft.variantId));
        if (variant) for (let index=0;index<variant.options.length;index++) {
          const select = nativePicker()?.querySelectorAll('select')[index];
          if (select && select.value !== variant.options[index]) await changeOption(index,variant.options[index]);
        }
      }
      const product = JSON.parse(JSON.stringify(draft.product));
      product.forEach(view=>view.elements?.forEach(element=>{if(element.parameters)element.parameters.autoSelect=false;}));
      await waitFor(fpd(),'productCreate',()=>fpd().loadProduct(product,false));
      const saved = draft.state || {};
      state.map = maps().find(map=>saved.mapName ? map.name===saved.mapName : map.index===saved.mapIndex) || maps()[0];
      if (Number.isInteger(state.map?.nativeIndex)) fpd().currentProductIndex=state.map.nativeIndex;
      state.color=saved.color || '#ffffff';state.sea=Boolean(saved.sea);
      state.heading=saved.heading || '';state.font=saved.font || '';
      state.titleName=saved.titleName;state.titleId=saved.titleId;state.textNumber=saved.textNumber || 0;
      state.step=Number.isInteger(saved.step) ? Math.max(0,Math.min(4,saved.step)) : 0;
      fpd().deselectElement();resize();
    },notice,true);
  }
  async function restoreDraft() {
    if (restoreStarted) return;restoreStarted=true;
    try {
    const returned = await account()?.ready;
    if (returned?.draft) {
      await applySavedDraft(returned.draft,t.pending_restored);
      restoredAccountName=returned.name;draftRestored=true;
      if (returned.intent==='list' && !account().error()) accountDesignsDialog();
      else accountSaveDialog(returned.intent==='save-confirmed' && !account().error());
      return;
    }
    const params = new URLSearchParams(location.search), pendingId=params.get('mwk-pending') || '';
    const pending=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pendingId);
    const draft=savedDraft(pending ? pendingDraftKey+pendingId : draftKey);
    if (!draft || draftRestored || (!pending && params.get('mwk-draft')!=='1')) {
      if (account()?.error()) accountSaveDialog();
      else if(params.get('mwk-saved')==='1')accountDesignsDialog();
      return;
    }
    draftRestored=true;
    await applySavedDraft(draft,pending ? t.pending_restored : t.restored_notice);
    if(pending && params.get('mwk-save')==='1')accountSaveDialog();
    } finally {document.documentElement.classList.remove('mwk-account-returning');}
  }
  function selectedText() {
    if (!state.open || state.busy) return;
    const element = fpd()?.currentElement;
    if (!element || element.getType?.() !== 'text' || !element.isEditable) return;
    const changed = state.step !== 2 || String(state.titleId) !== String(element.id);
    state.titleId = element.id; state.titleName = element.title; state.heading = element.text; state.font = element.fontFamily; state.step = 2;
    if (changed) render();
    else {
      const input = panel.querySelector('#mwk-assistant-heading');
      const font = panel.querySelector('#mwk-assistant-font');
      const preview = panel.querySelector('.mwk-assistant-font-preview');
      if (input) input.value = state.heading;
      if (font) font.value = state.font;
      if (preview) { preview.textContent = state.heading; preview.style.fontFamily = state.font; }
    }
  }
  function showStep(index) {
    state.step = index;
    if (index === 3) root()?.querySelector('.fpd-nav-item[data-module="designs"]')?.click();
    render();
  }
  function announce(message, error = false) {
    if (!panel) return;
    const status = panel.querySelector('[data-assistant-status]');
    status.textContent = message;
    status.classList.toggle('mwk-assistant-error', error);
  }
  function resize() {
    requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }
  function close() {
    gallery?.close();
    saveDialog?.close();
    state.open = false;
    panel.hidden = true;
    root()?.classList.remove('mwk-assistant-open');
    resize();
    root()?.querySelector('[data-pos="modal"] .fpd-close:not(.fpd-done)')?.click();
    if (new URLSearchParams(location.search).has('li-key')) location.assign('/cart');
    else document.getElementById('mwk-assistant-start')?.focus();
  }
  async function run(action, message, propagate = false) {
    if (state.busy) return;
    state.busy = true;
    panel.setAttribute('aria-busy', 'true');
    panel.querySelectorAll('button,input,select').forEach(control => control.disabled = true);
    announce(t.applying);
    try {
      await action();
      state.busy = false;
      render();
      announce(message || '');
    } catch (error) {
      state.busy = false;
      render();
      announce(error.message || t.unsupported, true);
      if (propagate) throw error;
    } finally {
      panel.removeAttribute('aria-busy');
    }
  }
  function waitFor(instance, event, action, accept = () => true) {
    return new Promise((resolve, reject) => {
      const handler = detail => {
        if (!accept(detail)) return;
        clearTimeout(timer);
        instance.removeEventListener(event, handler);
        resolve(detail);
      };
      const timer = setTimeout(() => {
        instance.removeEventListener(event, handler);
        reject(new Error(t.timeout));
      }, 12000);
      instance.addEventListener(event, handler);
      try { action(); } catch (error) {
        clearTimeout(timer);
        instance.removeEventListener(event, handler);
        reject(error);
      }
    });
  }
  async function loadMap(map) {
    const instance = fpd();
    if (!instance?.productCreated) throw new Error(t.not_ready);
    const products = instance.products?.[0]?.category ? instance.products[instance.currentCategoryIndex].products : instance.products;
    const product = map.product || products?.[map.nativeIndex ?? map.index];
    if (!Array.isArray(product)) throw new Error(t.unsupported);
    const heading = ownedTitle();
    const savedHeading = heading && { title: heading.title, text: heading.text };
    const customTransforms = elements().filter(element => element.isCustom).map(element => ({
      title: element.title, type: element.getType?.(), content: element.text || element.source,
      options: { autoCenter: false, ...Object.fromEntries(['left','top','scaleX','scaleY','originX','originY','angle','flipX','flipY'].map(key => [key, element[key]])) }
    }));
    const selected = selectedMapLayers();
    await waitFor(instance, 'productCreate', () => instance.loadProduct(withMapLayers(product, selected, map), true));
    const remaining = elements().filter(element => element.isCustom);
    for (const saved of customTransforms) {
      const index = remaining.findIndex(element => element.title === saved.title && element.getType?.() === saved.type && (element.text || element.source) === saved.content);
      if (index >= 0) setOptions(remaining.splice(index, 1)[0], saved.options);
    }
    instance.deselectElement();
    if (savedHeading && !ownedTitle()) {
      const restored = elements().find(element => element.getType?.() === 'text' && element.title === savedHeading.title && element.text === savedHeading.text);
      state.titleId = restored?.id ?? null;
    }
    if (Number.isInteger(map.nativeIndex)) instance.currentProductIndex = map.nativeIndex;
    state.map = map;
    state.sea = map.sea;
    if (!map.sea && /^#[0-9a-f]{6}$/i.test(state.color)) {
      const bg = background();
      if (bg) setOptions(bg, { fill: state.color });
    }
    syncMapProperties();
    resize();
  }
  async function restartDesign() {
    const instance = fpd();
    const map = state.map || maps()[0];
    const products = instance.products?.[0]?.category ? instance.products[instance.currentCategoryIndex].products : instance.products;
    const product = map.product || products?.[map.nativeIndex ?? map.index];
    if (!Array.isArray(product)) throw new Error(t.unsupported);
    await waitFor(instance, 'productCreate', () => instance.loadProduct(JSON.parse(JSON.stringify(product)), false));
    if (Number.isInteger(map.nativeIndex)) instance.currentProductIndex = map.nativeIndex;
    Object.assign(state, { map, sea:map.sea, color:background()?.fill || '#ffffff', titleId:null, titleName:null, textNumber:0, heading:'', font:'', step:0 });
    draftRestored = true; restoreStarted = true; restoredAccountName = '';
    syncMapProperties(); instance.deselectElement(); resize();
  }
  function confirmRestart() {
    if (state.busy || document.getElementById('mwk-assistant-restart')) return;
    if (!state.open) open();
    if (!state.open) return;
    const dialog = document.createElement('dialog');
    dialog.id = 'mwk-assistant-restart';
    dialog.setAttribute('aria-labelledby','mwk-assistant-restart-title');
    dialog.innerHTML = `<h2 id="mwk-assistant-restart-title">${esc(t.restart_title)}</h2><p>${esc(t.restart_hint)}</p><footer>${button(t.restart_cancel,'data-restart-cancel','mwk-assistant-secondary')}${button(t.restart_confirm,'data-restart-confirm','mwk-assistant-primary')}</footer>`;
    dialog.querySelector('[data-restart-cancel]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-restart-confirm]').addEventListener('click',()=>{dialog.close();run(restartDesign,t.restarted);});
    dialog.addEventListener('close',()=>dialog.remove());
    dialog.addEventListener('keydown',event=>event.stopPropagation());
    document.body.append(dialog);dialog.showModal();
  }
  function background() {
    return elements().find(element => /hintergrundfarbe ändern/i.test(element.title || ''));
  }
  async function chooseMap(map) {
    const target = maps().find(item => item.family === map.family && item.sea === state.sea) || map;
    await loadMap(target);
    if (!state.sea) {
      const bg = background();
      if (bg) setOptions(bg, { fill: state.color });
    }
  }
  async function chooseColor(color) {
    const catalog = maps();
    const family = state.map?.family || catalog.find(map => map.nativeIndex === fpd()?.currentProductIndex)?.family || 'states';
    const target = catalog.find(map => map.family === family && map.sea === (color === 'sea'));
    if (!target) throw new Error(t.unsupported);
    if (state.sea !== target.sea) await loadMap(target);
    state.map = target;
    state.sea = target.sea;
    if (color !== 'sea') {
      const bg = background();
      if (!bg) throw new Error(t.unsupported);
      setOptions(bg, { fill: color });
      state.color = color;
    }
    fpd()?.deselectElement();
  }
  async function saveHeading() {
    const value = state.heading.trim();
    if (!value) throw new Error(t.enter_heading);
    let element = ownedTitle();
    if (!element) {
      const instance = fpd(), c = canvas();
      const before = new Set(elements().map(item => item.id));
      const options = { ...instance.currentViewInstance.options.customTextParameters, isCustom: true, _calcWidth: true, fontFamily: state.font || fonts()[0] };
      do { state.titleName = `${t.heading_element} ${++state.textNumber}`; } while (elements().some(item => item.title === state.titleName));
      const textCount = elements().filter(item => item.getType?.() === 'text' && item.isCustom).length;
      await waitFor(instance, 'elementAdd', () => c.addElement('text', value, state.titleName, options), () => elements().some(item => !before.has(item.id) && item.getType?.() === 'text'));
      element = elements().find(item => !before.has(item.id) && item.getType?.() === 'text');
      if (!element) throw new Error(t.unsupported);
      state.titleId = element.id;
      const box = background();
      const width = box?.width || c.getWidth(), height = box?.height || c.getHeight();
      setOptions(element, { left: width / 2, top: height * Math.min(.12 + textCount * .08, .8), originX: 'center', originY: 'center', fontSize: 38, angle: 0 });
    }
    setOptions(element, { text: value, fontFamily: state.font || element.fontFamily });
    if (fpd().ensureUsedFonts) await fpd().ensureUsedFonts();
    element.canvas.requestRenderAll();
    fpd().deselectElement();
    state.font = element.fontFamily;
  }
  function button(label, attributes = '', className = '') {
    return `<button type="button" class="${className}" ${attributes}>${esc(label)}</button>`;
  }
  function textElements() {
    return elements().filter(element => element.getType?.() === 'text' && element.isCustom);
  }
  function openGallery() {
    gallery?.close();
    const dialog = document.createElement('dialog');
    gallery = dialog;
    dialog.id = 'mwk-assistant-gallery';
    dialog.setAttribute('aria-labelledby', 'mwk-assistant-gallery-title');
    dialog.innerHTML = `<header><h2 id="mwk-assistant-gallery-title">${esc(t.gallery_title)}</h2>${button('×',`data-gallery-close aria-label="${esc(t.gallery_close)}" autofocus`)}</header><div class="mwk-assistant-gallery-grid">${maps().map(map => `<button type="button" data-template="${map.index}" aria-pressed="${state.map?.index === map.index}"><img src="${esc(map.image)}" alt="" width="360" height="240"><strong>${esc(map.name)}</strong></button>`).join('')}</div><p>${esc(t.design_preserved)}</p>`;
    const returnFocus = panel.querySelector('[data-more-designs]');
    dialog.querySelectorAll('img').forEach(image => image.addEventListener('error', () => {
      const notice = document.createElement('span');
      notice.className = 'mwk-assistant-preview-unavailable';
      notice.textContent = t.preview_unavailable;
      image.replaceWith(notice);
    }));
    dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => event.stopPropagation());
    dialog.addEventListener('close', () => { dialog.remove(); if (gallery === dialog) gallery = null; returnFocus?.focus(); });
    dialog.querySelectorAll('[data-template]').forEach(control => control.addEventListener('click', async () => {
      dialog.querySelectorAll('button').forEach(item => item.disabled = true);
      await run(async () => {
        await loadMap(maps().find(map => map.index === Number(control.dataset.template)));
        const bg = background();
        if (!state.sea && /^#[0-9a-f]{6}$/i.test(bg?.fill)) state.color = bg.fill;
        dialog.close();
      });
      dialog.querySelectorAll('button').forEach(item => item.disabled = false);
    }));
    document.body.append(dialog);
    dialog.showModal();
  }
  const nativePicker = () => document.querySelector('#MainContent variant-selects,#MainContent variant-radios,#MainContent variant-picker');
  function currentVariant() {
    const data = document.getElementById('mwk-accessory-catalog');
    if (!data) return null;
    const catalog = JSON.parse(data.textContent);
    const id = Number(document.querySelector('#MainContent product-form input[name="id"]')?.value);
    const variant = catalog.mapVariants.find(item => item.id === id);
    return variant && { ...variant, currency: catalog.currency };
  }
  async function changeOption(index, value) {
    const select = nativePicker()?.querySelectorAll('select')[index];
    if (!select) throw new Error(t.unsupported);
    document.dispatchEvent(new CustomEvent('mwk:assistant-options'));
    await new Promise((resolve,reject) => {
      const done = () => { clearTimeout(timer); document.removeEventListener('mwk:assistant-variant-updated', done); resolve(); };
      const timer = setTimeout(() => { document.removeEventListener('mwk:assistant-variant-updated', done); reject(new Error(t.timeout)); },15000);
      document.addEventListener('mwk:assistant-variant-updated',done);
      select.value = value;
      select.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  function deliveryMarkup(variant) {
    if (!variant?.available || !config.arrival) return '';
    const options = variant.options?.join(' ').replace(/\s/g,'') || '';
    const partner = /KR12080/i.test(variant.sku || '') || (/keilrahmen/i.test(options) && /120[x×]80/i.test(options));
    const countries = config.arrival.countries;
    return `<section class="mwk-assistant-arrival" data-mwk-arrival data-mwk-arrival-date-only aria-labelledby="mwk-assistant-arrival-title"><h3 id="mwk-assistant-arrival-title">${esc(t.delivery_title)}</h3><select id="mwk-assistant-country" aria-label="${esc(t.delivery_country)}" aria-describedby="mwk-assistant-arrival-note">${countries.map(country=>`<option value="${esc(country.code)}" ${country.code===config.arrival.country?'selected':''}>${esc(country.name)}</option>`).join('')}</select><div data-mwk-arrival-group="${partner?'partner':'regular'}"><p data-mwk-arrival-date role="status" aria-live="polite">${esc(t.delivery_loading)}</p></div>${partner?`<p class="mwk-assistant-partner">${esc(t.delivery_partner)}</p>`:''}<small id="mwk-assistant-arrival-note">${esc(t.delivery_hint)}</small><p class="mwk-assistant-handmade">${esc(t.handmade)}</p><script type="application/json" data-mwk-arrival-ranges>${JSON.stringify(config.arrival.ranges).replace(/</g,'\\u003c')}</script></section>`;
  }
  function render() {
    const labels = [t.map_step, t.background_step, t.heading_step, t.cliparts_step, t.review_step];
    panel.innerHTML = `<header class="mwk-assistant-head"><div><span class="mwk-assistant-eyebrow">${esc(t.test_badge)}</span><h2>${esc(t.title)}</h2></div>${button('×',`data-assistant-close aria-label="${esc(t.close)}"`,'mwk-assistant-close')}</header><nav class="mwk-assistant-progress" aria-label="${esc(t.steps)}">${labels.map((label, index) => `<button type="button" data-step="${index}" aria-label="${esc(label)}" ${index === state.step ? 'aria-current="step"' : ''}>${esc(label).replace(/(Karten)(design)|(Hinter)(grund)|(Produkt)(auswahl)/g,(_,a,b,c,d,e,f)=>`${a||c||e}<wbr>${b||d||f}`)}</button>`).join('')}</nav><div class="mwk-assistant-content"><p class="mwk-assistant-question">${esc([t.map_question,t.color_question,t.heading_question,t.cliparts_question,t.review_question][state.step])}</p><div data-assistant-fields></div><p data-assistant-status role="status" aria-live="polite"></p></div><footer class="mwk-assistant-footer"><div>${state.step ? button(t.back, 'data-assistant-back', 'mwk-assistant-secondary') : ''}${state.step < 4 ? button(t.next,'data-assistant-next','mwk-assistant-primary') : button(entryParams.has('li-key') ? t.cart_save : t.cart_finish,`data-assistant-finish ${!currentVariant()?.available ? 'disabled' : ''}`,'mwk-assistant-primary')}</div></footer>`;
    const fields = panel.querySelector('[data-assistant-fields]');
    if (state.step === 0) {
      fields.innerHTML = `<div class="mwk-assistant-maps">${maps().filter(map => !map.sea && ['states','borders'].includes(map.family)).map(map => `<button type="button" data-map="${map.index}" aria-pressed="${state.map?.family === map.family}" class="mwk-assistant-map"><img src="${esc(map.image)}" alt="" width="280" height="180"><strong>${esc(map.states ? t.map_states : t.map_borders)}</strong><span>${esc(map.states ? t.states_hint : t.borders_hint)}</span></button>`).join('')}</div>${button(t.more_designs,'data-more-designs','mwk-assistant-secondary mwk-assistant-discover')}${state.map && !['states','borders'].includes(state.map.family) ? `<p class="mwk-assistant-note"><strong>${esc(state.map.name)}</strong></p>` : ''}<fieldset class="mwk-assistant-map-options"><legend>${esc(t.map_options)}</legend>${mapLayers.map(layer => `<label><input type="checkbox" data-map-layer="${layer.key}" ${selectedMapLayers()[layer.key] ? 'checked' : ''}><span>${esc(t[layer.key])}</span></label>`).join('')}</fieldset><p class="mwk-assistant-note">${esc(t.design_preserved)}</p>${button(t.restart,'data-assistant-restart','mwk-assistant-link')}`;
    } else if (state.step === 1) {
      const colors = [['#ffffff',t.white],['sea',t.sea],['#eee9d5',t.beige],['#cecdcd',t.gray]];
      fields.innerHTML = `<div class="mwk-assistant-colors">${colors.map(([color,label]) => `<button type="button" data-color="${color}" ${color === 'sea' && !maps().some(map => map.family === state.map?.family && map.sea) ? 'disabled' : ''} aria-pressed="${color === 'sea' ? state.sea : !state.sea && state.color === color}"><span class="mwk-assistant-swatch ${color === 'sea' ? 'mwk-assistant-sea' : ''}" style="--swatch:${color === 'sea' ? '#d7e7ee' : color}"></span>${esc(label)}</button>`).join('')}</div><form data-color-form><label for="mwk-assistant-color">${esc(t.custom_color)}</label><div class="mwk-assistant-input-row"><input id="mwk-assistant-color-picker" type="color" value="${esc(state.color)}" aria-label="${esc(t.color_picker)}"><input id="mwk-assistant-color" name="color" type="text" value="${esc(state.color)}" placeholder="#E8DFCF" maxlength="7" spellcheck="false" autocomplete="off" pattern="#[0-9a-fA-F]{6}" aria-describedby="mwk-assistant-color-hint">${button(t.apply,'data-apply-color','mwk-assistant-secondary')}</div><small id="mwk-assistant-color-hint">${esc(t.hex_hint)}</small></form>`;
    } else if (state.step === 2) {
      const element = ownedTitle();
      if (element) { state.heading = element.text; state.font = element.fontFamily; }
      const fontList = fonts();
      state.font ||= fontList[0];
      fields.innerHTML = `<form data-heading-form><label for="mwk-assistant-heading">${esc(t.heading_label)}</label><input id="mwk-assistant-heading" name="heading" type="text" value="${esc(state.heading)}" placeholder="${esc(t.heading_placeholder)}" maxlength="100" autocomplete="off"><label for="mwk-assistant-font">${esc(t.font_label)}</label><select id="mwk-assistant-font">${fontList.map(font => `<option value="${esc(font)}" ${font === state.font ? 'selected' : ''}>${esc(font)}</option>`).join('')}</select><p class="mwk-assistant-font-preview" style="font-family:'${esc(state.font)}',sans-serif">${esc(state.heading || t.heading_placeholder)}</p>${button(element ? t.update_heading : t.add_heading,'data-add-heading','mwk-assistant-primary')}</form>${button(t.more_text,'data-assistant-add-text','mwk-assistant-secondary mwk-assistant-add-text')}${button(t.without_heading,'data-without-heading','mwk-assistant-link')}<div class="mwk-assistant-text-list">${textElements().length ? `<p>${esc(t.existing_texts)}</p>${textElements().map(item => button(item.text,`data-edit-text="${esc(item.id)}"`,'mwk-assistant-text-item')).join('')}` : ''}</div><p class="mwk-assistant-note">${esc(t.drag_hint)}</p>`;
    } else if (state.step === 3) {
      const catalog = cliparts();
      clipartKey = catalog.map(item => item.source).join('|');
      fields.innerHTML = `<p class="mwk-assistant-note">${esc(t.cliparts_hint)}</p><div class="mwk-assistant-cliparts">${catalog.map((item,index) => `<button type="button" data-clipart="${index}" aria-label="${esc(t.add_clipart)}: ${esc(item.title)}"><img src="${esc(item.source)}" alt="" width="96" height="96"><span>${esc(item.title.replace(/\.[^.]+$/, '').replace(/[_-]/g,' '))}</span></button>`).join('')}</div>${!catalog.length ? `<p>${esc(t.cliparts_loading)}</p>` : ''}`;
    } else {
      const selects = [...(nativePicker()?.querySelectorAll('select') || [])];
      const variant = currentVariant();
      const money = variant && new Intl.NumberFormat(document.documentElement.lang || 'de-DE',{style:'currency',currency:variant.currency || 'EUR'}).format(variant.price / 100);
      fields.innerHTML = `${selects.map((select,index) => `<label for="mwk-assistant-option-${index}">${esc(select.closest('.product-form__input')?.querySelector('label')?.textContent.trim() || select.name)}</label><select id="mwk-assistant-option-${index}" data-native-option="${index}">${[...select.options].map(option => `<option value="${esc(option.value)}" ${option.selected ? 'selected' : ''} ${option.disabled ? 'disabled' : ''}>${esc(option.textContent)}</option>`).join('')}</select>`).join('')}<div class="mwk-assistant-price"><span>${esc(t.price_label)}</span><strong>${esc(money || '')}</strong></div>${deliveryMarkup(variant)}${!variant?.available ? `<p class="mwk-assistant-error">${esc(t.unavailable)}</p>` : ''}`;

    }
    bind();
    document.dispatchEvent(new CustomEvent('mwk:arrival-refresh'));
  }
  function bind() {
    panel.querySelector('[data-assistant-close]').addEventListener('click', close);
    panel.querySelectorAll('[data-step]').forEach(control => control.addEventListener('click', () => showStep(Number(control.dataset.step))));
    panel.querySelector('[data-assistant-back]')?.addEventListener('click', () => showStep(state.step - 1));
    panel.querySelector('[data-assistant-next]')?.addEventListener('click', () => {
      if (state.step === 2 && state.heading.trim()) return run(async () => { await saveHeading(); showStep(3); });
      showStep(state.step + 1);
    });
    panel.querySelectorAll('[data-clipart]').forEach(control => control.addEventListener('click', () => run(async () => {
      const choice = cliparts()[Number(control.dataset.clipart)];
      if (!choice) throw new Error(t.unsupported);
      const before = new Set(elements().map(item => item.id));
      await waitFor(fpd(),'elementAdd',() => choice.item.click(),event => event.detail?.element?.getType?.() === 'image' && !before.has(event.detail.element.id));
      const added = elements().find(item => !before.has(item.id) && item.getType?.() === 'image');
      smallClipart(added);
    },t.clipart_added)));
    panel.querySelector('[data-more-designs]')?.addEventListener('click',openGallery);
    panel.querySelector('[data-assistant-restart]')?.addEventListener('click',confirmRestart);
    panel.querySelectorAll('[data-map-layer]').forEach(control => control.addEventListener('change', () => run(() => chooseMapLayer(control.dataset.mapLayer, control.checked))));
    panel.querySelectorAll('[data-map]').forEach(control => control.addEventListener('click', () => run(() => chooseMap(maps().find(map => map.index === Number(control.dataset.map))))));
    panel.querySelectorAll('[data-color]').forEach(control => control.addEventListener('click', () => run(() => chooseColor(control.dataset.color))));
    panel.querySelectorAll('[data-native-option]').forEach(control => control.addEventListener('change', () => run(() => changeOption(Number(control.dataset.nativeOption),control.value))));
    const colorForm = panel.querySelector('[data-color-form]');
    const colorPicker = panel.querySelector('#mwk-assistant-color-picker');
    colorPicker?.addEventListener('input', event => { colorForm.elements.color.value = event.target.value; });
    colorPicker?.addEventListener('change', event => run(() => chooseColor(event.target.value)));
    panel.querySelector('#mwk-assistant-color')?.addEventListener('input', event => { if (/^#[0-9a-f]{6}$/i.test(event.target.value)) colorPicker.value = event.target.value; });
    const applyColor = event => {
      event.preventDefault();
      const value = colorForm.elements.color.value.trim();
      if (!/^#[0-9a-f]{6}$/i.test(value)) return announce(t.hex_error,true);
      run(() => chooseColor(value));
    };
    colorForm?.addEventListener('submit', applyColor);
    panel.querySelector('[data-apply-color]')?.addEventListener('click',applyColor);
    panel.querySelector('[data-assistant-add-text]')?.addEventListener('click', () => run(async () => {
      if (state.heading.trim()) await saveHeading();
      state.titleId = null; state.titleName = null; state.heading = ''; render();
      panel.querySelector('#mwk-assistant-heading')?.focus();
    }));
    panel.querySelectorAll('[data-edit-text]').forEach(control => control.addEventListener('click', () => {
      const element = elements().find(item => String(item.id) === control.dataset.editText);
      if (!element) return;
      state.titleId = element.id; state.titleName = element.title; state.heading = element.text; state.font = element.fontFamily; render();
      panel.querySelector('#mwk-assistant-heading')?.focus();
    }));
    const headingForm = panel.querySelector('[data-heading-form]');
    headingForm?.addEventListener('submit', event => { event.preventDefault(); run(saveHeading); });
    panel.querySelector('[data-add-heading]')?.addEventListener('click', () => run(saveHeading));
    panel.querySelector('#mwk-assistant-heading')?.addEventListener('input', event => {
      state.heading = event.target.value;
      panel.querySelector('.mwk-assistant-font-preview').textContent = state.heading || t.heading_placeholder;
    });
    panel.querySelector('#mwk-assistant-font')?.addEventListener('change', event => {
      state.font = event.target.value;
      panel.querySelector('.mwk-assistant-font-preview').style.fontFamily = state.font;
    });
    panel.querySelector('[data-without-heading]')?.addEventListener('click', () => {
      const element = ownedTitle();
      if (element) element.canvas.removeElement(element);
      state.titleId = null; state.heading = ''; showStep(state.step + 1);
    });
    panel.querySelector('[data-assistant-finish]')?.addEventListener('click', () => {
      root()?.querySelector('[data-pos="modal"] .fpd-done')?.click();
    });
    for (const [attribute,module] of [['cliparts','designs'],['more-text','text']]) {
      panel.querySelector(`[data-assistant-${attribute}]`)?.addEventListener('click', () => {
        close(); root()?.querySelector(`.fpd-nav-item[data-module="${module}"]`)?.click();
      });
    }
  }
  function open() {
    if (!fpd()?.productCreated || !document.body.classList.contains('fpd-modal-designer-visible')) return;
    const catalog = maps();
    if (!catalog.length) return;
    state.map = catalog.find(map => map.name === fpd().productViews?.[0]?.productTitle?.trim()) || catalog.find(map => map.index === fpd().currentProductIndex) || catalog[0];
    state.sea = state.map.sea;
    const bg = background();
    if (bg?.fill && /^#[0-9a-f]{6}$/i.test(bg.fill)) state.color = bg.fill;
    const r = root();
    if (!panel || !r.contains(panel)) {
      panel = document.createElement('aside');
      panel.id = 'mwk-design-assistant';
      panel.setAttribute('aria-label', t.title);
      r.append(panel);
      panel.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); close(); } });
    }
    state.open = true;
    panel.hidden = false;
    r.classList.add('mwk-assistant-open');
    fpd().deselectElement();
    render();
    resize();
    panel.querySelector('button')?.focus();
    const layer = mapLayers.find(item => item.key === 'antarctica');
    const existing = layer && elements().find(element => element.title === layer.title);
    const appearance = layer && mapLayerAppearance(layer, currentMapFamily(), currentMapSea());
    if (existing && (existing.source !== appearance.source || (appearance.fill && existing.fill !== appearance.fill))) run(() => chooseMapLayer('antarctica', true));
  }
  function start(event) {
    event?.preventDefault();
    const url = new URL(location.href);
    if (url.pathname !== config.productUrl) {
      const target = new URL(config.productUrl,location.origin);
      target.searchParams.set('mwk-assistant','1');
      if (url.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id',url.searchParams.get('preview_theme_id'));
      location.href = target.href;
      return;
    }
    if (autoStarted && !event) return;
    autoStarted = true;
    if (!document.body.classList.contains('fpd-modal-designer-visible')) document.getElementById('fpd-customize-button')?.click();
    const wait = () => {
      if (document.body.classList.contains('fpd-modal-designer-visible') && fpd()?.productCreated) {
        open();
        if (!state.open) {requestAnimationFrame(wait);return;}
        document.documentElement.classList.remove('mwk-designer-entering');
        if (entryParams.get('mwk-new-design')==='1') run(restartDesign,t.restarted);
        else restoreDraft();
        return;
      }
      if (Date.now() - began > 15000) {document.documentElement.classList.remove('mwk-designer-entering');return;}
      requestAnimationFrame(wait);
    };
    const began = Date.now(); wait();
  }
  function install() {
    document.querySelectorAll('[data-mwk-assistant-entry]').forEach(link=>link.closest('li')?.remove());
    document.querySelectorAll('a[href*="/pages/individuell-gestalten"]').forEach(link=>{
      let url;try {url=new URL(link.href,location.origin);}catch(_){return;}
      if (url.origin!==location.origin) return;
      url.pathname=config.productUrl;url.searchParams.set('mwk-assistant','1');
      link.href=url.href;
    });
    const starter = document.getElementById('fpd-customize-button');
    if (starter && !document.getElementById('mwk-assistant-start')) {
      const button = document.createElement('button');
      button.type = 'button'; button.id = 'mwk-assistant-start'; button.className = 'button button--secondary'; button.textContent = t.start;
      starter.after(button);
    }
    const savedUrl=new URL(config.productUrl,location.origin);
    for(const [key,value] of Object.entries({preview_theme_id:config.themeId,'mwk-assistant':'1','mwk-saved':'1',pb:'0'}))savedUrl.searchParams.set(key,value);
    if(starter && !document.getElementById('mwk-assistant-saved-entry')){
      const link=document.createElement('a');link.id='mwk-assistant-saved-entry';
      link.href=savedUrl.href;link.className='mwk-assistant-saved-entry';link.textContent=t.account_saved_designs;
      (document.getElementById('mwk-assistant-start') || starter).after(link);
    }
    const r = root();
    r?.classList.toggle('mwk-assistant-cart-edit', new URLSearchParams(location.search).has('li-key'));
    const done = r?.querySelector('[data-pos="modal"] .fpd-done');
    if (done && !document.getElementById('mwk-assistant-save')) {
      const save = document.createElement('button');
      save.id = 'mwk-assistant-save'; save.type = 'button'; save.className = 'fpd-btn';
      save.textContent = t.save_design; save.title = t.save_scope; save.addEventListener('click',saveDraft);
      done.before(save);
    }
    if (done && !document.getElementById('mwk-assistant-saved')) {
      const saved = document.createElement('button');
      saved.id='mwk-assistant-saved';saved.type='button';saved.className='fpd-btn';
      saved.textContent=t.account_saved_designs;saved.addEventListener('click',accountDesignsDialog);
      const save=document.getElementById('mwk-assistant-save');
      if(save)save.after(saved);else done.before(saved);
    }
    if (r && !document.getElementById('mwk-assistant-designer-toggle')) {
      const toggle = document.createElement('button');
      toggle.type = 'button'; toggle.id = 'mwk-assistant-designer-toggle'; toggle.className = 'fpd-btn'; toggle.textContent = t.toggle;
      r.querySelector('fpd-actions-bar [data-pos="left"]')?.append(toggle);
    }
    if (fpd() && state.instance !== fpd()) {
      state.instance = fpd();
      state.instance.addEventListener('productCreate', () => { if (state.open && !state.busy) { render(); resize(); } });
      state.instance.addEventListener('elementSelect',selectedText);
      state.instance.addEventListener('elementModify',selectedText);
      state.instance.addEventListener('elementAdd',event => {
        const element = event.detail?.element;
        if (!state.open || state.step !== 3 || !fpd()?.productCreated || state.busy || !element?.isCustom || element.getType?.() !== 'image') return;
        if (cliparts().some(item => item.source === element.source || item.title === element.title)) requestAnimationFrame(() => smallClipart(element));
      });
    }
    if (!document.body.classList.contains('fpd-modal-designer-visible') && state.open) {
      state.open = false; panel.hidden = true; r?.classList.remove('mwk-assistant-open');
    }
    if (!autoStarted && (directEntry || entryParams.get('mwk-assistant') === '1') && starter && !starter.disabled && fpd()?.productCreated) start();
    if (!state.busy) syncMapProperties();
    if (state.open && state.step === 3 && !state.busy) {
      const key = cliparts().map(item => item.source).join('|');
      if (key !== clipartKey) render();
    }
  }
  // Variant changes can replace FPD's toolbar and product form with cloned DOM.
  document.body.addEventListener('click', event => {
    if (event.target.closest('#mwk-assistant-start')) start(event);
    if (event.target.closest('#mwk-assistant-designer-toggle')) state.open ? close() : open();
  });
  document.addEventListener('click',event=>{
    if (!directEntry || !event.target.closest('#fpd [data-action="reset-product"]')) return;
    event.preventDefault();event.stopImmediatePropagation();
    event.target.closest('.fpd-dropdown-btn')?.click();
    confirmRestart();
  },true);
  document.addEventListener('click', event => { if (event.target.closest('.fpd-done,#MainContent .product-form__submit')) syncMapProperties(); }, true);
  observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; install(); });
  });
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled']});
  install();
})();
